module.exports = __webpack_public_path__ + "img/gfa_cover.4c5bfe40.jpg";